import _                 from 'lodash'
import React             from 'react'
import { Alert, Button } from 'react-bootstrap'

import { HorizontalForm } from 'alto-react-components/lib/components'

import InputSpecs        from './input_specs'
import SmartInputs       from './inputs'

export { InputSpecs }

# requirements:
# - attributes: model, inputs, defaultValues
# - props: action ('create'/'update'), record (entity), submit (callback)
# - state: ready (default true), notReadyMessage (default '')
export default class SmartForm extends React.Component
  constructor: (props, context) ->
    super(props, context)

    @state = { ready: true, notReadyMessage: '', values: {}, valid: true }

  # override these
  id:            null
  className:     null
  model:         'not given'
  inputs:        'all SmartForm subclasses must override inputs attribute'
  hiddenInputs:  []
  defaultValues: {}

  submit: ->
    @props.submit(@state.values)

  render: ->
    <HorizontalForm id={@id} className={@className}>
      {@errorDetailAlert()}
      {@formInputs()}
      {@buttons()}
    </HorizontalForm>

  errorDetailAlert: ->
    detail = @props.backendErrors.detail

    <Alert bsStyle='danger'>{detail}</Alert> if detail

  formInputs: ->
    if @state.ready
      specs = @inputSpecs().rejectInputs (spec) => spec.property in @hiddenInputs

      <SmartInputs specs={specs} defaultValues={@defaultValues}
       action={@props.action} record={@props.record} errors={@props.backendErrors}
       onChange={(values) => @setState({ values })}
       onValidChange={(valid) => @setState({ valid })} />

    else
      <Alert>{@state.notReadyMessage}</Alert>

  buttons: ->
    <HorizontalForm.Offset>
      {@submitButton()}
    </HorizontalForm.Offset>

  submitButton: ->
    switch @props.action
      when 'create'
        submitCaption = 'Vytvořit'
        submitStyle   = 'success'
      when 'update'
        submitCaption = 'Uložit'
        submitStyle   = 'warning'

    <Button disabled={not @state.valid} onClick={@submit.bind(@)}
     bsStyle={submitStyle}>{submitCaption}</Button>

  inputSpecs: ->
    @_inputSpecs ?= new InputSpecs(if _.isFunction(@inputs) then @inputs() else @inputs)
